// MessageSettingsDialog - MODULE
// ***********************************************************************************************************************
import { Box, Grid } from "@mui/material";
import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { ISessionState } from "../../../models/session/sessionState";
import { Dialog } from "../../framework/Dialog/Dialog";
import { IPageNavMenuItem, PageNavMenuItems } from "../../framework/PageNav/PageNavMenuItems";
import { GridRow } from "source/components/framework/Grid/GridRow";
import { DocumentKeywordList } from "./DocumentKeywordList";
import { DocumentTemplateList } from "./DocumentTemplateList";
import { FileFilterList } from "./FileFilterList";
import { DocumentOtherSettings, IDocumentOtherSettingsCancelResult } from "./DocumentOtherSettings";
import { DialogButtons } from "source/components/framework/Dialog/DialogButtons";

/* eslint-disable no-unused-vars */
export const enum DocumentSettingsDialogMenuItem {
    Keywords = "1",
    FileFilters = "2",
    DocumentTemplates = "3",
    SharedDocumentTemplates = "4",
    OtherSettings = "5"
}
/* eslint-enable no-unused-vars */

//DocumentSettingsDialog
export interface IDocumentSettingsDialogProp {
    sessionState: ISessionState;
    companyId: string;
    classes?: string;
    settingsActions: IPageNavMenuItem[];
    onClose: () => void;
}

export interface IDocumentSettingsDialogState {
    activeMenuItem: DocumentSettingsDialogMenuItem;
}

export class DocumentSettingsDialog extends React.Component<IDocumentSettingsDialogProp, IDocumentSettingsDialogState> {
    otherSettingsRef = React.createRef<DocumentOtherSettings>();

    constructor(props: IDocumentSettingsDialogProp) {
        super(props);
        this.state = {
            activeMenuItem: DocumentSettingsDialogMenuItem.Keywords,
        };
    }

    // #region Other Settings
    onOtherSettingsCancel = async (): Promise<IDocumentOtherSettingsCancelResult> => {
        return await this.otherSettingsRef.current.handleCancel();
    };

    handleOtherSettingsSave = async () => {
        await this.otherSettingsRef.current.handleSave();
    };
    // #endregion Other Settings

    handleToggleActiveMenuItem = async (menuItem: DocumentSettingsDialogMenuItem) => {
        const state = this.state;
        if (state.activeMenuItem === menuItem) return;
        //Check current tab cancel
        if (state.activeMenuItem === DocumentSettingsDialogMenuItem.OtherSettings) {
            const result = await this.onOtherSettingsCancel();
            if (!result.canChangePage) return;
        }
        //Set new tab active
        this.setState({
            activeMenuItem: menuItem
        });
    };

    handleCancel = async (closeDialog: boolean) => {
        if (!closeDialog) return;
        this.props.onClose();
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <Dialog
                id="documentSettingsDialog"
                title={Translations.Settings}
                maxWidth="lg"
                maxHeight="100%"
                onClose={() => this.handleCancel(true)}
                body={
                    <GridRow flexGrow={2}>
                        <Grid item sm={3}>
                            <PageNavMenuItems
                                activeId={state.activeMenuItem}
                                items={props.settingsActions}
                                onToggleMenuItem={this.handleToggleActiveMenuItem}
                            />
                        </Grid>
                        <Grid item sm={9} display="flex" flexDirection="column" flexGrow={2}>
                            {(state.activeMenuItem === DocumentSettingsDialogMenuItem.Keywords) && (
                                <DocumentKeywordList
                                    companyId={props.companyId}
                                />
                            )}
                            {state.activeMenuItem === DocumentSettingsDialogMenuItem.DocumentTemplates && (
                                <DocumentTemplateList
                                    companyId={props.companyId}
                                />
                            )}
                            {state.activeMenuItem === DocumentSettingsDialogMenuItem.SharedDocumentTemplates &&
                                <DocumentTemplateList
                                    companyId={null}
                                />
                            }
                            {state.activeMenuItem === DocumentSettingsDialogMenuItem.FileFilters &&
                                <FileFilterList
                                    companyId={props.companyId}
                                />
                            }
                            {state.activeMenuItem === DocumentSettingsDialogMenuItem.OtherSettings &&
                                <DocumentOtherSettings
                                    ref={this.otherSettingsRef}
                                    sessionState={props.sessionState}
                                    companyId={props.companyId}
                                />
                            }
                        </Grid>
                    </GridRow>
                }
                buttons={
                    state.activeMenuItem !== DocumentSettingsDialogMenuItem.OtherSettings
                        ? [{ title: Translations.Close, variant: "outlined", onClick: () => this.handleCancel(true) }]
                        : null
                }
                actions={
                    state.activeMenuItem === DocumentSettingsDialogMenuItem.OtherSettings
                        ? <Box display="flex" justifyContent="end" width="100%">
                            <DialogButtons
                                onCancel={() => this.handleCancel(true)}
                                onSave={this.handleOtherSettingsSave}
                            />
                        </Box>
                        : null
                }
            />
        );
    }
}